import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import {ButtonFavourite} from '../button-favourite';
import {TrackSchema} from '../../types/schema';

export interface FavouriteButtonCompatProps {
  track: TrackSchema;
  size?: number;
  className?: string;
  withLabel?: boolean;
  i18n?: {
    favourite: string;
    unfavourite: string;
  }
}

@inject(deps) @observer
export class FavouriteButtonCompat extends Component<FavouriteButtonCompatProps> {
  render() {
    const { track, size, withLabel, i18n = FavouriteButtonCompat.i18n } = this.props;
    const { sync, tracks, removed } = this.props.model.playlist;
    const { playlistFavourites } = this.props.model.env;

    if (!track) return null;

    let isFavourite = track.user ? track.user.favourited : false;

    if (tracks[playlistFavourites].indexOf(track.identity) !== -1) {
      isFavourite = true;
    }

    if (removed[playlistFavourites].indexOf(track.identity) !== -1) {
      isFavourite = false;
    }

    const label = withLabel
      ? (isFavourite ? i18n.unfavourite : i18n.favourite)
      : void 0;

    const isSync = sync[playlistFavourites].indexOf(track.identity) !== -1;

    return (
      <ButtonFavourite
        className={this.props.className}
        isFavourite={isFavourite}
        isSync={isSync}
        size={size}
        onClick={this.handleClick.bind(this, isFavourite)}
        label={label}
      />
    )
  }

  handleClick = (isFavourite: boolean, event: React.MouseEvent<any>) => {
    event.preventDefault();
    if (!this.props.model.user.user) {
      return this.props.controller.onboarding.openSignUpModal();
    }

    if (isFavourite) {
      this.props.controller.playlist.unfavourite(this.props.track.identity);
    } else {
      this.props.controller.playlist.favourite(this.props.track.identity);
    }
  };

  static i18n = {
    favourite: 'Favourite',
    unfavourite: 'Unfavourite',
  };
}